export default function triggerLangOverlay() {
  const isPresent = document.querySelector(".custom-lang-switcher");
  if (!isPresent) {
    return;
  }

  const triggers = document.querySelectorAll("[data-lang-trigger]");
  const target = document.querySelectorAll("[data-lang-target]");
  // const close = document.querySelector("[data-lang-close]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      target.forEach((item) => {
        item.classList.toggle("active");
      });
    });
  });

  // close.addEventListener("click", function () {
  //   target.classList.remove("active");
  // });
}
